import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { RecurrenceEnum } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';
import { SIMULATION_ENDPOINT_PREFIX } from 'routes/HumanResourcesModule/Simulation/helpers/constants';
import { AgentGrade } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/GradeAdvancement/helpers/types';
import { RQAPICall } from 'store/APIClient';

const AGENT_GRADE_API_KEY = 'hr_simulation_agent_grade';

/**
 * A function that uses the given simulation ID and agent information. It returns the grade and ehcelon of the agent.
 *
 * @param {number} simulationId - The ID of the simulation

 */
export const usePostAgentGrade = ({
    simulationId,
    recurrence,
    orgChartHrSoftwareId,
    jobNumber,
    agentSoftwareId,
    mantyStatus,
}: {
    simulationId: number;
    recurrence: RecurrenceEnum;
    orgChartHrSoftwareId: string;
    jobNumber: string;
    agentSoftwareId: string;
    mantyStatus: string;
}): UseQueryResult<AgentGrade> => {
    const endpoint = `${SIMULATION_ENDPOINT_PREFIX}/${simulationId}/agent_grade`;
    return useQuery({
        queryKey: [
            AGENT_GRADE_API_KEY,
            agentSoftwareId,
            orgChartHrSoftwareId,
            jobNumber,
            recurrence,
            mantyStatus,
        ],
        queryFn: async () => {
            const getResponse = await RQAPICall({
                endpoint,
                method: 'POST',
                body: {
                    agentSoftwareId,
                    orgChartHrSoftwareId,
                    jobNumber,
                    recurrence,
                    mantyStatus,
                },
            });
            return getResponse.content.data;
        },
        meta: {
            useGlobalOnError: true,
        },
    });
};
